import DepositModal from './DepositModal';
export default DepositModal;
